export default {
  contestNotificationCard: 'dt.contest.common.contestNotificationCard',
  contestNotificationWidget: 'dt.contest.common.contestNotificationWidget',
  contestInviteCard: 'dt.contest.common.contestInviteCard',
  contestRestartCard: 'dt.contest.common.contestRestartCard',
  standingsEntryProgressBar: {
    underTheLine: 'dt.contest.common.standingsEntryProgressBar.underTheLine',
    overTheLine: 'dt.contest.common.standingsEntryProgressBar.overTheLine',
  },
  enterContestModal: {
    modal: 'dt.contest.common.enterContestModal.modal',
    title: 'dt.contest.common.enterContestModal.title',
    action: {
      decrement: 'dt.contest.common.enterContestModal.action.decrement',
      increment: 'dt.contest.common.enterContestModal.action.increment',
      numberOfEntries: 'dt.contest.common.enterContestModal.action.numberOfEntries',
      zipCode: 'dt.contest.common.enterContestModal.action.zipCode',
      zipTermsCheckbox: 'dt.contest.common.enterContestModal.action.zipTermsCheckbox',
      createEntries: 'dt.contest.common.enterContestModal.action.createEntries',
      depositToEnter: 'dt.contest.common.enterContestModal.action.depositToEnter',
      cancel: 'dt.contest.common.enterContestModal.cancel',
    },
    successScreen: {
      container: 'dt.contest.common.enterContestModal.successScreen.container',
      title: 'dt.contest.common.enterContestModal.successScreen.title',
    },
  },
};
